/* global G */
import { curry } from 'lib/util'
import { remove } from 'app/_shared/events/notification/alert'

/**
 * Deletes a notification
 *
 * Uses the incoming `key` or `id` and the `id` of the notification saved in the action
 * state as a fallback.
 *
 * @param {Function} callback                 callback to execute
 * @param {Gaia.AppModule.Spec} module        module composition
 * @param {Gaia.Component.Spec} component     action component
 * @param {Gaia.AppModule.EventHandler} event triggered event
 * @returns {Promise<void>}
 * @private
 */
const _remove = async (callback, module, component, event) => {
  const { key, id } = event?.detail || event || {}
  const { notification } = module[G.STATE][G.ACTION][G.STATE]
  const { id: notificationId } = notification
  const targetKey = key || id || notificationId

  await remove(module, component, { id: targetKey }, callback, event)
}

export default curry(_remove)
